export default __webpack_public_path__ + "static/media/Ellipse 22.c6bfedf1.png";